<template>
  <v-card flat>
    <v-card-title class="subheader py-0">
      <v-icon small class="mr-1" color="blue">money</v-icon>
      评审标准
      <v-spacer/>
      <v-btn flat round color="primary" dark>
        <v-icon v-if = "false">add</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider color="orange"/>
    <v-card-text class="pt-0">
      <v-data-table
          class="dense"
          :headers="headers"
          :items="items"
          hide-actions
      >
        <template slot="items" slot-scope="props">
          <td><span :style="`padding-left: ${(props.item.level-1)*16}px`">{{props.item.name}}</span></td>
          <td>{{props.item.weight}}</td>
          <td>{{props.item.note}}</td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
const baseURI = '/api/proj/review-template/detail';
export default {
  name: "ReviewTemplate",
  props: {
    review: Object
  },
  data: () => ({
    items: [],

    headers: [
      {text: '评审指标', sortable: false, value: 'name',width: 80},
      {text: '权重', sortable: false, value: 'weight',width: 30},
      {text: '说明', sortable: false, value: 'note',width: 160},
    ],

  }),
  watch: {
    review(p) {
      this.axios
          .get(`${baseURI}/${p.templateId}`)
          .then(
              rsp => {
                this.items = rsp.data;
              }
          )
    }
  },
}
</script>

<style scoped>

</style>